"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const ActionTypes = require("../../actionTypes/compare");
const Actions = require("../../actions/compare");
const _generatePreviewEpics = require("../../modules/files/generatePreview/epics");
const errorHandling_1 = require("../../utils/errorHandling");
const generatePreviewEpics = _generatePreviewEpics.default('compare');
function fetchRevision(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_BEFORE_REVISION_REQUEST ||
        action.type === ActionTypes.FETCH_AFTER_REVISION_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/files/${action.payload.revisionUuid}/READABLE`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        return ActionTypes.iFetchRevisionSuccessData
            .decode({ payload: response })
            .fold((error) => (0, rxjs_1.of)(action.type === ActionTypes.FETCH_BEFORE_REVISION_REQUEST
            ? Actions.fetchBeforeRevisionFailure((0, errorHandling_1.parseValidationError)(error))
            : Actions.fetchAfterRevisionFailure((0, errorHandling_1.parseValidationError)(error))), ({ payload }) => (0, rxjs_1.of)(action.type === ActionTypes.FETCH_BEFORE_REVISION_REQUEST
            ? Actions.fetchBeforeRevisionSuccess(payload)
            : Actions.fetchAfterRevisionSuccess(payload)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchBeforeRevisionFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.allEpics = redux_observable_1.combineEpics(generatePreviewEpics.convert, fetchRevision);
//# sourceMappingURL=index.js.map